import { render, staticRenderFns } from "./DanhGiaDDATForm.vue?vue&type=template&id=7125570a&"
import script from "./DanhGiaDDATForm.vue?vue&type=script&lang=js&"
export * from "./DanhGiaDDATForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports